import React from 'react';
import { Body, Box } from '@hover/blueprint';
import { successWrapperStyle } from './styles';
import Smartphone from '../../../assets/images/Smartphone';

const Success: React.FC = () => (
  <Box {...successWrapperStyle}>
    <Body color="brandNavy.500" size={400}>
      Check your phone to get started.
    </Body>
    <Box ml={200}>
      <Smartphone />
    </Box>
  </Box>
);

export default Success;
